import React from 'react';
import { ClockIcon, HeartIcon, BrainIcon } from 'lucide-react';
export const PainPoints = () => {
  return <section className="w-full bg-gray-100 py-12 px-4 md:px-8" data-id="element-283">
      <div className="max-w-5xl mx-auto" data-id="element-284">
        {/* Personal story section */}
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-285">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-286">
            To był zwykły czwartkowy wieczór
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-287">
            Stałam w kuchni, patrząc na ten jeden kubek po herbacie na stole i
            czułam, jak coś we mnie pęka.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-288">
            Sekundę wcześniej mój 15-letni syn wyszedł z kuchni, zostawiając
            bałagan. Mąż siedział w salonie, scrollując telefon. Z pokoju mamy
            dobiegało wołanie "Kasiu, chodź tu na chwilę!".
          </p>
          <p className="text-gray-700 mb-4" data-id="element-289">
            A ja... ja po prostu eksplodowałam.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-290">
            Zaczęłam krzyczeć. Trzaskałam szafkami. "DLACZEGO NIKT W TYM DOMU
            NIE POTRAFI PO SOBIE POSPRZĄTAĆ?! DLACZEGO WSZYSTKO JEST NA MOJEJ
            GŁOWIE?!"
          </p>
          <p className="text-gray-700 mb-4" data-id="element-291">
            Syn patrzył na mnie przerażony. Mąż w końcu oderwał wzrok od
            telefonu. Mama znów zawołała z pokoju. A ja zamknęłam się w łazience
            i rozpłakałam.
          </p>
          <div className="bg-gray-100 border-l-4 border-red-500 p-4 my-6" data-id="element-292">
            <p className="text-lg font-bold text-gray-800" data-id="element-293">
              "To nie ja. Ja taka nie jestem"
            </p>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-294">
            Siedziałam na zimnych kafelkach, oparta plecami o drzwi. Co się ze
            mną stało?
          </p>
          <p className="text-gray-700 mb-4" data-id="element-295">
            Jestem kobietą, która zawsze dawała radę. Która ogarniała dom,
            pracę, dzieci i chorą mamę bez mrugnięcia okiem. A teraz? Teraz
            wściekłam się o kubek.
          </p>
          <p className="text-gray-700 font-bold" data-id="element-296">
            Ale prawda była taka, że to nie chodziło o kubek.
          </p>
        </div>
        {/* Pain points amplification */}
        <div className="bg-gray-200 rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-297">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6" data-id="element-298">
            Życie, które mnie przytłoczyło
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-299">
            Mam 42 lata. Należę do tego, co psychologowie nazywają "pokoleniem
            kanapkowym" - kobiet, które jednocześnie opiekują się dziećmi i
            starzejącymi się rodzicami.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-300">
            Od trzech lat mama mieszka z nami, bo po udarze nie może już
            mieszkać sama. Alzheimer postępuje, a wraz z nim jej zależność ode
            mnie.
          </p>
          <div className="my-8" data-id="element-301">
            <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-302">
              Mój dzień wygląda tak:
            </h3>
            <div className="bg-white rounded-lg p-4 shadow-sm mb-4" data-id="element-303">
              <div className="flex items-start" data-id="element-304">
                <ClockIcon className="h-6 w-6 text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-305" />
                <p className="text-gray-700" data-id="element-306">
                  Rano budzę dzieci do szkoły, szykuję śniadania, pomagam mamie
                  się ubrać i umyć. W międzyczasie pakuję kanapki, sprawdzam czy
                  syn ma wszystkie książki, przypominam o klasówce.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-sm mb-4" data-id="element-307">
              <div className="flex items-start" data-id="element-308">
                <BrainIcon className="h-6 w-6 text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-309" />
                <p className="text-gray-700" data-id="element-310">
                  Potem praca - na szczęście mogę pracować zdalnie, bo inaczej
                  nie dałabym rady. Ale "praca zdalna" oznacza, że co chwilę
                  ktoś mnie woła. Mama nie może znaleźć okularów (które ma na
                  nosie). Dzwoni szkoła, że córka źle się czuje.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-sm mb-4" data-id="element-311">
              <div className="flex items-start" data-id="element-312">
                <HeartIcon className="h-6 w-6 text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-313" />
                <p className="text-gray-700" data-id="element-314">
                  Po południu odbieranie dzieci, korepetycje, treningi.
                  Gotowanie obiadu dla pięciu osób z różnymi wymaganiami
                  dietetycznymi. Mama je tylko to, co lubiała 30 lat temu. Syn
                  jest na diecie sportowca. Córka została wegetarianką.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-315">
              <p className="text-gray-700" data-id="element-316">
                Wieczorem sprawdzanie prac domowych, kąpanie mamy (coraz
                trudniejsze, bo nie poznaje łazienki), układanie jej spać. A
                potem jeszcze pranie, sprzątanie, przygotowanie na jutro.
              </p>
              <p className="text-gray-700 mt-2" data-id="element-317">
                I tak dzień po dniu. Tydzień po tygodniu.
              </p>
            </div>
          </div>
          <div className="bg-red-100 border-l-4 border-red-500 p-4 my-6" data-id="element-318">
            <p className="text-lg font-bold text-gray-800" data-id="element-319">
              Czy to brzmi znajomo?
            </p>
          </div>
        </div>
        {/* Breaking point story */}
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-320">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-321">
            Moment, w którym wszystko się zmieniło
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-322">
            Następnego dnia po moim wybuchu nie mogłam wstać z łóżka. Nie
            fizycznie - po prostu psychicznie nie miałam siły. Leżałam i
            patrzyłam w sufit, czując totalną pustkę.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-323">
            Mąż wziął wolne. Pierwszy raz od miesięcy sam zrobił dzieciom
            śniadanie i zawiózł je do szkoły. Kiedy wrócił, usiadł na brzegu
            łóżka.
          </p>
          <div className="bg-gray-100 p-4 my-4 rounded-lg border-l-4 border-gray-400" data-id="element-324">
            <p className="text-gray-700 font-italic" data-id="element-325">
              "Kasia, tak nie może być. Ty się zaraz rozchorujesz."
            </p>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-326">
            Miał rację. Ale co miałam zrobić? Oddać mamę do domu opieki? Nigdy
            sobie tego nie wybaczę. Przestać pracować? Nie stać nas na to.
            Zrezygnować z dzieci? To absurd.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-327">
            Tego wieczoru, kiedy wszyscy już spali, włączyłam laptopa. Musiałam
            znaleźć jakieś rozwiązanie, bo czułam, że jeszcze jeden taki dzień i
            naprawdę się rozsypię.
          </p>
          <div className="mt-8" data-id="element-328">
            <a href="https://veiramode.com/products/nie-zapomnij-o-sobie-ebook" className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg transform hover:scale-105 transition-all" data-id="element-329">
              Co odkryłam tamtej nocy? →
            </a>
          </div>
        </div>
      </div>
    </section>;
};